class ClassificationItemModel {

    constructor() {
        this.classificationItemId = 0;
        this.classificationItemIndex = 0;
        this.classificationItemName = ""
        this.dragList = [];

    }
    getAsJson = () => {
        let obj = {}
        obj.classificationItemId = this.classificationItemId
        obj.classificationItemIndex = this.classificationItemIndex
        obj.classificationItemName = this.classificationItemName

        obj.dragList = []
        for (let i = 0; i < this.dragList.length; i++) {
            obj.dragList.push(this.dragList[i].getAsJson())
        }

        return obj
    }


    initFromJson = (obj) => {
        this.classificationItemId = obj.classificationItemId
        this.classificationItemIndex = obj.classificationItemIndex
        this.classificationItemName = obj.classificationItemName
        this.dragList = []
        if (obj.dragList) {
            for (let i = 0; i < obj.dragList.length; i++) {
                this.dragList.push(obj.dragList[i].getAsJson())
            }
        }
    }

}
export default ClassificationItemModel
